import { CanDeactivateFn } from '@angular/router';

/** Componentes que bloquean la salida si hay cambios pendientes. */
export interface CanDeactivateWithUnsavedChanges {
  hasUnsavedChanges: boolean;
  confirmDeactivate(): Promise<boolean> | boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateWithUnsavedChanges> = (
  component
) => {
  if (!component?.hasUnsavedChanges) {
    return true;
  }
  return component.confirmDeactivate();
};
